<div class="wrapper" ngbTooltip="{{ 'Monitors' | translate }}">
  <a (click)="overlay.toggle($event);">
    <svg class="svg-inline--fa fa-w-20" [ngStyle]="{color: site24MainStatusUp() ? 'green' : 'red'}">
      <use xlink:href="#heart"></use>
    </svg>
  </a>
</div>
<qm-overlay-panel #overlay [stickTo]="'left-bottom'" [appendTo]="'body'" [dismissable]="true">
  <div class="card" style="margin-top: 0.8em;">
    <ng-container *ngIf="tenantsMonitors?.monitorList">
      <div class="monitor-list">
        <div *ngFor="let monitor of tenantsMonitors.monitorList">
          <div
            class="d-flex flex-row monitor"
            ngbTooltip="{{monitor.last_polled_time}}"
            [ngStyle]="{color: monitor.status === 1 ? 'green' : 'red'}">
            {{monitor.name}} : {{site24StatusAsString(monitor.status)}}
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</qm-overlay-panel>

<i class="fas fa-heart-rate" data-fa-symbol="heart"></i>

